import { Select } from "antd";
import { Button, Card, Col, Container, Label, Row, Spinner } from "reactstrap";
import { CustomerAndVendorHeader } from "../../components/Headers/Headers";
import NotesCard from "../../components/cards/NotesCard";
import { DropdownLabel } from "../../components/dropdown/DropdownLabel";
import FormInput from "../../components/formInput/FormInput";
import PageName from "../../components/react_helmet/PageName";
import LogTable from "../../components/table/LogTable";
import SaleOrderList from "../../components/table/SaleOrderList";
import { orderTerms, statesArray } from "../../data";
import useCustomerDetails from "./customHooks/useCustomerDetails";
import BillingDetailsCard from "../../components/cards/BillingDetailsCard";
import { Link } from "react-router-dom/cjs/react-router-dom";
import CountButton from "../../components/button/CountButton";
import CustomerDetailsSkeleton from "../../components/skeleton/CustomerDetailsSkeleton";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
const CustomerPayment = ({
  billingData,
  setBillingData,
  note,
  setNote,
  addCustomerNotes,
  taxCerfificate, setTaxCertificate
}) => {
  return (
    <div className="payment-section">
      <div className="d-flex align-items-center mb-4">
        <div className="bg-primary-soft p-2 rounded-8 me-3">
          <h3 className="primary-color mb-0 fs-18 fw-bold">Payment Settings</h3>
        </div>
      </div>

      <Row>
        <Col md={6}>
          <div className="mb-3">
            <Label className="mb-1 fw-600 text-muted fs-13 uppercase letter-spacing-1">Payment Terms</Label>
            <DropdownLabel
              customClassName={"modern-dropdown"}
              placeholder={"Select Terms"}
              options={orderTerms?.map((i) => i.value)}
              value={billingData?.terms}
              onSelect={(e, value) =>
                setBillingData({
                  ...billingData,
                  terms: value?.children,
                })
              }
              className={"drop_down_label_style w-100"}
            />
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="mb-1 fw-600 text-muted fs-13 uppercase letter-spacing-1">Credit Limit</Label>
            <FormInput
              placeholder={"0.00"}
              type={"number"}
              className="modern-input"
              value={billingData?.creditLimit}
              handleChange={(e) => {
                setBillingData({
                  ...billingData,
                  creditLimit: e.target.value,
                });
              }}
            />
          </div>
        </Col>
      </Row>

      <div className="mt-0 p-3 bg-light-soft rounded-12 border border-dashed">
        <Label className="mb-2 fw-600 text-dark fs-14">Customer Notes</Label>
        <NotesCard
          className={"modern-textarea mb-3"}
          height={"110px"}
          width={"100%"}
          type={"textarea"}
          placeholder={"Type your internal notes here..."}
          value={note}
          handleChange={(e) => setNote(e.target.value)}
        />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
          <div className="w-100">
            <Label className="mb-1 fw-600 text-muted fs-12 uppercase">Tax Exempt Certificate</Label>
            <input
              type="file"
              accept=".pdf,.jpg,.png"
              className="form-control modern-file-input"
              onChange={(e) => {
                const file = e.target.files[0];
                setTaxCertificate(file);
              }}
            />
          </div>

          <Button
            className="create-user-btn whitespace-nowrap"
            style={{ minWidth: "140px" }}
            onClick={() => {
              addCustomerNotes();
            }}
          >
            Save Note
          </Button>
        </div>
      </div>
    </div>
  );
};

const CreditCard = ({ customerInfo }) => {
  const maskCardNumber = (cardNumber) => {
    const cleaned = cardNumber.replace(/\s/g, "");
    const last4 = cleaned.slice(-4);
    return `•••• •••• •••• ${last4}`;
  };

  return (
    <>
      <div className="d-flex flex-wrap gap-3 mt-2">
        {customerInfo?.cards?.map((card, index) => (
          <div
            key={index}
            className="flex-grow-1 p-4 rounded-16 border-0 shadow-sm"
            style={{
              background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
              color: "white",
              minWidth: "280px",
              position: "relative",
              overflow: "hidden"
            }}
          >
            <div className="mb-4 d-flex justify-content-between align-items-start">
              <div>
                <p className="mb-0 text-white-50 fs-11 uppercase fw-600 letter-spacing-1">Card Holder</p>
                <p className="mb-0 fw-bold fs-15 text-white">{card.cardHolder}</p>
              </div>
              <div className="text-end">
                <p className="mb-0 text-white-50 fs-11 uppercase fw-600 letter-spacing-1">Expires</p>
                <p className="mb-0 fw-bold fs-15 text-white">{card.expiryDate}</p>
              </div>
            </div>

            <div>
              <p className="mb-0 text-white-50 fs-11 uppercase fw-600 letter-spacing-1">Card Number</p>
              <p className="mb-0 fs-18 fw-bold text-white letter-spacing-2">
                {maskCardNumber(card.cardNumber)}
              </p>
            </div>

            {/* Visual Flair */}
            <div style={{
              position: "absolute",
              bottom: "-20px",
              right: "-20px",
              width: "100px",
              height: "100px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "50%"
            }}></div>
          </div>
        ))}
      </div>
    </>
  );
};
const CustomerDetails = () => {
  const {
    note,
    setNote,
    billingData,
    setBillingData,
    addCustomerNotes,
    handleUpdate,
    saleOrdersByCustomers,
    customerInfo,
    loading,
    loader,
    handleApprove,
    handleReject,
    taxExempt,
    setTaxExempt,
    taxExemptStates,
    setTaxExemptStates, soLoading, taxCerfificate, setTaxCertificate,
    page, setPage, pageSize, totalPages
  } = useCustomerDetails();
  return (
    <div className="settings-container ">
      <PageName title={`${customerInfo?.first_name ? customerInfo?.first_name + ' ' + customerInfo?.last_name : 'Customer'} Details`} />
      {loading ? (
        <div className="mt-4">
          <CustomerDetailsSkeleton />
        </div>
      ) : (
        <Container>
          <div className="mb-4">
            <CustomerAndVendorHeader
              handleApprove={handleApprove}
              handleReject={handleReject}
              name="Customer"
              customerData={customerInfo}
              ID={customerInfo?.id}
              handleUpdate={handleUpdate}
              loader={loader}
            />
          </div>

          <Row className="mt-0 pt-0 g-4">
            <Col lg={5}>
              <BillingDetailsCard
                billingData={billingData}
                setBillingData={setBillingData}
              />
            </Col>
            <Col lg={7}>
              <Card className="border-0 shadow-sm rounded-16 p-4 bg-white h-100" style={{ border: "1px solid #f1f5f9" }}>
                {customerInfo?.type === "company" ? (
                  <CustomerPayment
                    billingData={billingData}
                    setBillingData={setBillingData}
                    note={note}
                    setNote={setNote}
                    addCustomerNotes={addCustomerNotes}
                    taxCerfificate={taxCerfificate}
                    setTaxCertificate={setTaxCertificate}
                  />
                ) : (
                  <div className="empty-payment-state py-5 text-center">
                    <h5 className="text-muted fs-14">Individual customer profile does not require payment settings.</h5>
                  </div>
                )}

                <div className="mt-4">
                  {customerInfo?.type === 'individual' && !customerInfo?.cards?.length && (
                    <div className="p-4 bg-light rounded-12 text-center text-muted fs-13 border border-dashed">
                      No active credit cards on file.
                    </div>
                  )}
                  {customerInfo?.type === 'individual' && customerInfo?.cards?.length > 0 && (
                    <div className="mt-2">
                      <h5 className="text-dark fw-bold mb-3 fs-16">Stored Payment Methods</h5>
                      <CreditCard customerInfo={customerInfo} />
                    </div>
                  )}
                </div>

                {customerInfo?.type === 'company' && (
                  <div className="mt-0 pt-0 border-top">
                    <div className="d-flex align-items-center justify-content-between p-3 bg-primary-soft rounded-12">
                      <div className="d-flex align-items-center gap-3">
                        <Label className="mb-0 fw-bold text-primary fs-15">Tax Exempt Status</Label>
                        <input
                          type="checkbox"
                          className="modern-checkbox"
                          checked={taxExempt}
                          onChange={(e) => setTaxExempt(e.target.checked)}
                          style={{ width: "20px", height: "20px" }}
                        />
                      </div>
                      <div className="w-50">
                        {taxExempt && (
                          <Select
                            mode="tags"
                            className="modern-select-multiple w-100"
                            placeholder="Select Exempt States"
                            options={statesArray}
                            value={taxExemptStates}
                            onChange={(value) => setTaxExemptStates(value)}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Card>
            </Col>
          </Row>

          {/* Customer Documents (Tax Certificate & W-9 Form) */}
          {((customerInfo?.taxCertificate || customerInfo?.tax_exemption) || (customerInfo?.w9_form || customerInfo?.w9Form || customerInfo?.w9)) && (
            <Row className="mt-4 g-3">
              {(customerInfo?.taxCertificate || customerInfo?.tax_exemption) && typeof (customerInfo?.taxCertificate || customerInfo?.tax_exemption) === 'string' && (
                <Col md={(customerInfo?.w9_form || customerInfo?.w9Form || customerInfo?.w9) ? 6 : 12}>
                  <div className="p-3 bg-white rounded-12 border shadow-sm d-flex justify-content-between align-items-center h-100">
                    <div className="d-flex align-items-center gap-3">
                      <div className="bg-success-soft p-2 rounded-8">
                        <h5 className="mb-0 text-success fw-bold fs-14">Tax Certificate Available</h5>
                      </div>
                    </div>
                    <a
                      href={customerInfo?.taxCertificate || customerInfo?.tax_exemption}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-action bg-primary-soft text-primary px-4"
                    >
                      View Document
                    </a>
                  </div>
                </Col>
              )}

              {(customerInfo?.w9_form || customerInfo?.w9Form || customerInfo?.w9) && typeof (customerInfo?.w9_form || customerInfo?.w9Form || customerInfo?.w9) === 'string' && (
                <Col md={(customerInfo?.taxCertificate || customerInfo?.tax_exemption) ? 6 : 12}>
                  <div className="p-3 bg-white rounded-12 border shadow-sm d-flex justify-content-between align-items-center h-100">
                    <div className="d-flex align-items-center gap-3">
                      <div className="bg-success-soft p-2 rounded-8">
                        <h5 className="mb-0 text-success fw-bold fs-14">W-9 Form Available</h5>
                      </div>
                    </div>
                    <a
                      href={customerInfo?.w9_form || customerInfo?.w9Form || customerInfo?.w9}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-action bg-primary-soft text-primary px-4"
                    >
                      View Document
                    </a>
                  </div>
                </Col>
              )}
            </Row>
          )}

          <div className="mt-5">
            <div className="settings-card shadow-sm border-0">
              <CountButton title="Customer Sale Orders" count={totalPages} />
              <div className="p-0">
                {soLoading ? (
                  <div className="mt-3">
                    <TableSkeleton columns={8} />
                  </div>
                ) : (
                  <SaleOrderList
                    saleOrdersByCustomers={saleOrdersByCustomers}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    totalPages={totalPages}
                  />
                )}
              </div>
            </div>
          </div>

          <Row className="mt-4">
            <Col md={12}>
              {customerInfo?.type === 'company' && customerInfo?.cards?.length > 0 && (
                <div className="settings-card shadow-sm border-0 mb-4">
                  <h5 className="p-3 mb-0 fw-bold text-dark border-bottom fs-16">Corporate Payment Cards</h5>
                  <div className="p-3">
                    <CreditCard customerInfo={customerInfo} />
                  </div>
                </div>
              )}
            </Col>
          </Row>

          <div className="mt-4">
            <LogTable
              title="Interaction Logs & Notes"
              orderNotes={
                customerInfo?.notes?.sort((a, b) => b?.createdAt - a?.createdAt) ?? []
              }
            />
          </div>
        </Container>
      )}
    </div>
  );
};
export default CustomerDetails;
